import React from 'react';
import { preventMouseMove } from '../../../helpers/events';
import ActionButton from '../ActionButton';
import ChevronDownIcon from '../../../shared/components/Icons/ChevronDown';
import SalesIcon from '../../../shared/components/Icons/TicketType/Sales';
import PreorderIcon from '../../../shared/components/Icons/TicketType/Preorder';
import ElectronicIcon from '../../../shared/components/Icons/TicketType/Electronic';
import PaperIcon from '../../../shared/components/Icons/TicketType/Paper';
import Styled from './styled';
import useHelp from '../../../hooks/useHelp';
import SalesLandingIcon from '../../../shared/components/Icons/TicketType/SalesLandingIcon';
import PreorderLandingIcon from '../../../shared/components/Icons/TicketType/PreorderLandingIcon';
import ElectronicLandingIcon from '../../../shared/components/Icons/TicketType/ElectronicLandingIcon';
import PaperLandingIcon from '../../../shared/components/Icons/TicketType/PaperLandingIcon';
import useZoom from '../../../hooks/useZoom';
import BrokerIcon from '../../../shared/components/Icons/Marketplace/BrokerIcon';

const Help = () => {
  const { Widget } = window;
  const { isLanding, withAnnouncements } = Widget.settings;
  const { isHidden, t, basketSize, hide } = useHelp();
  const { zoomState } = useZoom();

  const withMinimap = !Widget.isMobile && !withAnnouncements && zoomState.zoomIndex >= 1;

  const renderText = () => {
    if (Widget.isMobile) {
      return (
        <div>
          <Styled.Paragraph>
            {t('navigationHelp_1')}
            <div>{t('navigationHelp_2')}</div>
          </Styled.Paragraph>

          <Styled.Paragraph>{t('navigationHelp_3')}</Styled.Paragraph>
        </div>
      );
    }

    if (withMinimap) {
      return (
        <div>
          <Styled.Paragraph>{t('help_text_1')}</Styled.Paragraph>
          <Styled.Paragraph>{t('help_text_2')}</Styled.Paragraph>
        </div>
      );
    }

    return (
      <div>
        <Styled.Paragraph>{t('no_minimap_help_text_1')}</Styled.Paragraph>
        <Styled.Paragraph>{t('no_minimap_help_text_2')}</Styled.Paragraph>
      </div>
    );
  };

  if (isHidden) return null;

  return (
    <Styled.Container offset={basketSize}>
      <Styled.Content onMouseMove={preventMouseMove}>
        <Styled.HideButton>
          <ActionButton onClick={hide} plain hovered>
            <ChevronDownIcon />
          </ActionButton>
        </Styled.HideButton>
        <Styled.Title>{t('hint')}</Styled.Title>
        {renderText()}
        {!isLanding && <Styled.TicketsTypeTitle>{t('ticketsType')}</Styled.TicketsTypeTitle>}
        <Styled.AvailabilityMessage>
          <Styled.AvailabilityItem>
            <div> {isLanding ? <SalesLandingIcon /> : <SalesIcon />}</div>
            <div> {t('announcement_sales')}</div>
          </Styled.AvailabilityItem>
          <Styled.AvailabilityItem>
            <div>{isLanding ? <PaperLandingIcon /> : <PaperIcon />}</div>
            <div>{t('paper_ticket')}</div>
          </Styled.AvailabilityItem>
          <Styled.AvailabilityItem>
            <div>{isLanding ? <PreorderLandingIcon /> : <PreorderIcon />}</div>
            <div>{t('announcement_preorder')}</div>
          </Styled.AvailabilityItem>
          <Styled.AvailabilityItem>
            <div>{isLanding ? <ElectronicLandingIcon /> : <ElectronicIcon />}</div>
            <div>{t('electronic_ticket')}</div>
          </Styled.AvailabilityItem>
          {!isLanding && (
            <Styled.AvailabilityItem>
              <div>{<BrokerIcon />}</div>
              <div>{t('brokerTickets')}</div>
            </Styled.AvailabilityItem>
          )}
        </Styled.AvailabilityMessage>
      </Styled.Content>
    </Styled.Container>
  );
};

export default Help;
